module.exports = __webpack_public_path__ + "static/img/znq0807.77df5c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znq0807.jpg
// module id = 9DsZ
// module chunks = 0